export const MEDIA_RESET = "MEDIA_RESET" as const;
export const MEDIA_PHOTO_GIPHY_SET = "MEDIA_PHOTO_GIPHY_SET" as const;
export const MEDIA_PHOTO_STOCK_SET = "MEDIA_PHOTO_STOCK_SET" as const;
export const MEDIA_PHOTO_WEB_SET = "MEDIA_PHOTO_WEB_SET" as const;
export const MEDIA_PHOTO_USED_SET = "MEDIA_PHOTO_USED_SET" as const;
export const MEDIA_VIDEO_USED_SET = "MEDIA_VIDEO_USED_SET" as const;
export const MEDIA_VIDEO_LIBRARY_SET = "MEDIA_VIDEO_LIBRARY_SET" as const;
export const MEDIA_SETTING_SET = "MEDIA_SETTING_SET" as const;
